import { css } from '@emotion/react';
import type { Theme } from '../theme';

/** Shared text-control styling for Input / Textarea / Select. */
export const controlBase = (t: Theme) => css`
  appearance: none;
  font-family: inherit;
  font-size: ${t.fontSize.base};
  color: ${t.color.fg.default};
  background: ${t.color.bg.default};
  border: 1px solid ${t.color.slate[500]}; /* Figma DS Inputs: slate/500 */
  border-radius: ${t.radius.base};
  padding: 0 ${t.control.px.md};
  height: ${t.control.height.md};
  width: 100%;
  min-width: 0;
  transition: border-color ${t.motion.fast} ${t.motion.ease}, box-shadow ${t.motion.fast} ${t.motion.ease};

  &:hover { border-color: ${t.color.blue[400]}; }
  &:focus {
    outline: none;
    border-color: ${t.color.primary.base};
    box-shadow: 0 0 0 3px ${t.color.blue[100]};
  }
  &::placeholder { color: ${t.color.fg.placeholder}; }
  &:disabled {
    background: ${t.color.bg.muted};
    color: ${t.color.fg.subtle};
    cursor: not-allowed;
  }
`;

export const errorRing = (t: Theme) => css`
  border-color: ${t.color.danger};
  &:focus { box-shadow: 0 0 0 3px ${t.color.red[100]}; }
`;

export const markdownBody = (t: Theme) => css`
  h1, h2, h3, h4, h5, h6 {
    margin: 16px 0 8px;
    line-height: 1.35;
    font-weight: ${t.fontWeight.semibold};
    color: ${t.color.fg.default};
  }
  h1 { font-size: ${t.fontSize.md}; }
  h2 { font-size: ${t.fontSize.base}; }
  h3, h4, h5, h6 { font-size: ${t.fontSize.sm}; }

  p { margin: 0 0 8px; }

  ul, ol {
    margin: 0 0 8px;
    padding-left: 20px;
  }
  li { margin-bottom: 4px; }

  code {
    font-size: ${t.fontSize.sm};
    background: ${t.color.bg.muted};
    border-radius: ${t.radius.sm};
    padding: 0 4px;
  }

  > *:first-of-type { margin-top: 0; }
  > *:last-child { margin-bottom: 0; }
`;
